export const LIGHT_GREEN = "#e3f0e9ff"
